import React, { useState } from 'react';
import { ExternalLink, Briefcase } from 'lucide-react';

export const CompanyHeader: React.FC = () => {
  const [imageError, setImageError] = useState(false);

  return (
    <div className="CompanyHeader flex flex-col items-center justify-center mb-8">
      <div className="flex items-center justify-center w-full max-w-xl mb-4">
        {imageError ? (
          <div className="flex items-center gap-3 text-blue-600">
            <Briefcase className="w-12 h-12" />
            <span className="text-2xl font-bold">C-OnPoint</span>
          </div>
        ) : (
          <img 
            src="https://cdn.brandfetch.io/idh7BRkI_M/w/700/h/150/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B" 
            alt="C-OnPoint Logo" 
            className="h-16 md:h-20 object-contain"
            onError={() => setImageError(true)}
          />
        )}
      </div>
      
      <div className="text-center max-w-2xl mx-auto">
        <p className="text-lg text-gray-700 mb-3">
          <span className="font-semibold">Confused by Microsoft licensing?</span> Worried about overpaying or non-compliance?
        </p>

        <p className="text-gray-600 mb-4">
          With 30 years of Microsoft licensing expertise, we've seen it all. Let us simplify your licensing, optimize your costs, and ensure you're getting exactly what you need.
        </p>

        <a
          href="https://onpointhq.com/capabilities/pro-services/microsoft-license/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors shadow-sm print:hidden"
        >
          <span>Get Expert Guidance</span>
          <ExternalLink className="w-4 h-4" />
        </a>

        <p className="text-sm text-gray-500 mt-3 print:hidden">
          m365.onpointhq.com
        </p>
      </div>
    </div>
  );
};